import { Injectable } from '@angular/core';
import { Diaparpreenc } from "../coninterfaces/conencdiaparpre";
import { Diaparpredet } from "../coninterfaces/condetdiaparpre";
import { ConfInicialesService } from 'src/app/servicios/conf-iniciales.service';
import { HttpClient } from '@angular/common/http';
import { Usuario } from '../../usuario';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CondiaparpreService {
  public way: string;
  public encabezadoDiaParpreSelectarray: Diaparpreenc[] = [];

  public _detdiaparprearray: Diaparpredet[] = [];
  get detdiaparprearray(): Diaparpredet[] {
    return this._detdiaparprearray;
  }
  set detdiaparprearray(value: Diaparpredet[]) {
    this._detdiaparprearray = value;
  }

  constructor(
    private http: HttpClient,
    public usuario: Usuario,
    private confIniciales: ConfInicialesService
  ) {
    this.way = sessionStorage.getItem('way');
  }

  validadetparprenum(numero, anio) {
    return this.http.post<any[]>(this.way + '/cont/diaparpre/cc7afd6bbb95700000000', {
      elementos: {
        p_numero: numero,
        p_anio: anio,
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  insertarencdiapar(item) {
    return this.http.post<any[]>(this.way + '/cont/diaparpre/95f8edf54ebb18000000', {
      elementos: {
        p_encdiapar_numero: item.ENCDIAPAR_NUMERO,
        p_com_codigo: '01',
        p_encparpre_anio: item.ENCPARPRE_ANIO,
        p_encdiapar_fecha: item.ENCDIAPAR_FECHA,
        p_encdiapar_concepto: item.ENCDIAPAR_CONCEPTO,
        p_usuidentificacion: this.usuario.identificacion,
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  insertardetdiapar(item) {
    return this.http.post<any[]>(this.way + '/cont/diaparpre/95f8edf54d7758000000', {
      elementos: {
        p_encdiapar_numero: item.ENCDIAPAR_NUMERO,
        p_com_codigo: '01',
        p_detdiapar_linea: Number(item.DETDIAPAR_LINEA),
        p_encparpre_anio: item.ENCPARPRE_ANIO,
        p_detparpre_numero: item.DETPARPRE_NUMERO,
        p_detdiapar_concepto: item.DETDIAPAR_CONCEPTO,
        p_detdiapar_mes: item.DETDIAPAR_MES,
        p_detdiapar_importe: Number(item.DETDIAPAR_IMPORTE),
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  eliminarregistro(numero) {
    return this.http.post<any[]>(this.way + '/cont/diaparpre/7565695d5b75dc000000', {
      elementos: {
        p_encdiapar_numero: numero,

      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getencdiapar(numero) {
    return this.http.post<any[]>(this.way + '/cont/diaparpre/83baebb1b256580', {
      elementos: {
        p_encdiapar_numero: numero,

      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getdetdiapar(numero) {
    return this.http.post<any[]>(this.way + '/cont/diaparpre/83bad775b256580', {
      elementos: {
        p_encdiapar_numero: numero,

      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  eliminarregistrodet(item) {
    return this.http.post<any[]>(this.way + '/cont/diaparpre/7565695d4d775c000000', {
      elementos: {
        p_encdiapar_numero: item.ENCDIAPAR_NUMERO,
        p_com_codigo: '01',
        p_detdiapar_linea: item.DETDIAPAR_LINEA

      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
}
